import { ToursContextProvider } from "./ToursContextProvider";
import { ToursIndex } from "./ToursIndex";
import ReactDOM from 'react-dom';
import React from "react";

export default function App({ data }) {
    return (
        <ToursContextProvider data={data}>
            <ToursIndex />
        </ToursContextProvider>
    )
}


const container = document.getElementById('toursIndex');

if (container)
{
    const data = Object.assign({}, container.dataset);
    ReactDOM.render(<App data={JSON.parse(data.data)} />, container);
}





// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/index.js